if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"onboarding","remotes":[]},
		chunkMatcher: function(chunkId) {return !/^(212|517|597|699|791|810)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}